export enum UserActionTypes {
  /* Client Brokers View */
  ClientBrokersLoadBrokers = '[Users/ClientBrokers/Page] Load Brokers',
  ClientBrokersLoadBrokersSuccess = '[Users/BrokerDetails/API] Load Brokers Success',
  ClientBrokersLoadBrokersFailure = '[Users/BrokerDetails/API] Load Brokers Failure',
  ClientBrokersResetSelection = '[Users/ClientBrokers/Page] Reset Selection',

  // DashEffects - this needs to be reworked
  DashLoadUsersForClientId = '[Users/Dash/Effects] Load Users For Client',
  DashLoadUsersForClientIdSuccess = '[Users/Dash/API] Load Users For Client Success',
  DashLoadUsersForClientIdFailure = '[Users/Dash/Effects] Load Users For Client Failure',

  // Policy Create Update
  PolicyCreateUpdateLoadUsers = '[Users/PolicyCreateUpdate/Page] Load Users For Client',
  PolicyCreateUpdateLoadUsersSuccess = '[Users/PolicyCreateUpdate/API] Load Users For Client Success',
  PolicyCreateUpdateLoadUsersFailure = '[Users/PolicyCreateUpdate/API] Load Users For Client Failure',
  PolicyCreateUpdateResetSelection = '[Users/PolicyCreateUpdate/Page] Reset Selection',

  // Policy Details
  PolicyDetailsLoadBroker = '[Users/PolicyCreateUpdate/Page] Load Broker',
  PolicyDetailsLoadBrokerSuccess = '[Users/PolicyCreateUpdate/API] Load Broker Success',
  PolicyDetailsLoadBrokerFailure = '[Users/PolicyCreateUpdate/API] Load Broker Failure',
  PolicyDetailsResetSelected = '[Users/PolicyCreateUpdate/Page] Reset Selected',
}
